module.exports = __webpack_public_path__ + "img/pic_xiaomistepthreeone.1a8b165f.png";